import React from 'react';
import { Route } from 'react-router';
import Layout from './components/Layout';
import Home from './components/Home';
import RegistrationGas from './components/Forms/RegistrationGas';
import RegistrationElectricity from './components/Forms/RegistrationElectricity';
import CancelGas from './components/Forms/CancellationGas';
import CancelElectricity from './components/Forms/CancellationElectricity';

export default () => (
  <Layout>
    <Route exact path='/' component={Home} />
    <Route path='/RegisterGas' component={RegistrationGas} />
    <Route path='/RegisterElectricity' component={RegistrationElectricity} />
    <Route path='/CancelGas' component={CancelGas} />
    <Route path='/CancelElectricity' component={CancelElectricity} />
  </Layout>
);



// WEBPACK FOOTER //
// ./src/App.js